export default function (game) {
  game.anims.create({
    key: 'attack',
    frames: 'attack',
    frameRate: 30,
  });
}
